<template>
    <div class="goodsList">
        <div class="titleHeader">
            <div class="title">爆款专区</div>
            <div class="more" @click="onMore('爆款专区')">
                <span class="tip" v-track:click :track-params="JSON.stringify({event: 108})">更多</span>
                <span class="icon"></span>
            </div>
        </div>
        <div class="goodsUl" ref="goodsUl" v-track:click :track-params="JSON.stringify({event: 108})">
            <div class="goodsLi" v-for="(item, index) in goodsData" :key="index" :class="{'mr20': goodsData.length>3}" @click="onDetail(item.id)">
                <div class="img">
                    <img :src="$viewImageNew(item.imgUrls, 400,400)" alt="">
                </div>
                <div class="content">
                    <div class="name">
                        {{item.name}}
                    </div>
                    <div class="saleP" v-if="$isPriceShow()"><i class="icon"></i><i>￥</i>{{ item.sellPrice }}</div>
                    <div class="saleP isPrice" v-else>会员价</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        goodsData: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        onDetail (item) {
            this.$emit('hotClick', item)
        },
        onMore (item) {
            this.$emit('hotMore', item)
        }
    }
}
</script>

<style lang="scss" scoped>
.goodsList {
    margin: 40px 24px 0;
    background-color: #fff;
    border-radius: 4px;
    .titleHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.pr20 {
            padding-right: 20px;
        }
        .title {
            font-family: PingFangSC;
            font-weight: bold;
            font-size: 34px;
            line-height: 48px;
            color: #333333;
        }
        .more {
            font-size: 26px;
            line-height: 36px;
            color: #888888;
            display: flex;
            align-items: center;
            .icon {
                width: 40px;
                height: 40px;
                background: url(../../../../assets/img/b2b/img_arrow_next@2x.png)
                    no-repeat;
                background-size: cover;
            }
        }
    }
    .goodsUl {
        // height: 400px;
        padding: 32px 0 40px 0;
        overflow-x: scroll;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        .goodsLi {
            margin-right: 40px;
            display: flex;
            justify-content: flex-start;
            width: 192px;
            display: inline-block;
            .img {
                position: relative;
                flex: 0 0 192px;
                height: 192px;
                background-color: #fafafa;
                display: flex;
                img {
                    align-self: center;
                    justify-self: center;
                    border-radius: 4px;
                    display: inline-block;
                    margin: 0 auto;
                    background: #f2f3f5;
                    object-fit: cover;
                }
            }
            .content {
                position: relative;
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                align-content: space-between;
                box-sizing: border-box;
                .name {
                    text-align: left;
                    font-size: 24px;
                    line-height: 32px;
                    padding-right: 14px;
                    height: 32px;
                    width: 100%;
                    color: #000000;
                    line-height: 32px;
                    font-weight: 400;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                    margin-bottom: 16px;
                    margin-top: 12px;
                }
                .saleP {
                    width: 100%;
                    height: 32px;
                    font-size: 32px;
                    line-height: 32px;
                    margin-bottom: 4px;
                    font-weight: bold;
                    color: #ff571f;
                    font-family: Helvetica;
                    i {
                        display: inline-block;
                        font-size: 24px;
                        transform: scale(0.92);
                        transform-origin: left -130%;
                    }
                    &.isPrice {
                        font-size: 28px;
                    }
                }
            }
        }
        .mr20 {
            margin-right: 20px;
        }
    }
}
</style>